import { TaskList } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const TaskIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <TaskList width={size} height={size} color={color} {...rest} />;

TaskIcon.displayName = 'TaskIcon';

export default TaskIcon;
